import { render, staticRenderFns } from "./TirarSelfie.vue?vue&type=template&id=6718762e&scoped=true&"
import script from "./TirarSelfie.vue?vue&type=script&lang=js&"
export * from "./TirarSelfie.vue?vue&type=script&lang=js&"
import style0 from "./TirarSelfie.vue?vue&type=style&index=0&id=6718762e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6718762e",
  null
  
)

export default component.exports